function initMembershipFloatingWidget() {
  var widgets = document.querySelector('.membership-floating-widget');
  if (!widgets) return;


  var closeButton = widgets.querySelector('.membership-floating-widget__close');
  if (!closeButton) return;

  closeButton.addEventListener('click', function () {
    widgets.classList.add('membership-floating-widget--hidden');
  });


  // Move Gorgias chat button up so it sits above the membership widget
  setTimeout(() => {
    let bufferHeight = widgets.offsetHeight+ 15;
    var gorgiasIframe = document.querySelector('#gorgias-chat-container iframe[title="Gorgias live chat messenger"]');
    if (gorgiasIframe) {
      gorgiasIframe.style.bottom = `${bufferHeight}px`;
    }
  }, 6000);
  setTimeout(() => {
    if (widgets) {
      widgets.classList.remove('membership-floating-widget--hidden');
    }
  }, 7000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMembershipFloatingWidget);
} else {
  initMembershipFloatingWidget();
}
